import { type BeaconClient } from "@beacon/client-core";
import { postSignedToService } from "../../platform/post-signed.js";

const utf8 = (s: string) => new TextEncoder().encode(s);

export interface AppealInput {
  action: string;    // TID of the flag/label being appealed
  statement: string; // sealed appeal text (required by lexicon — seal even if short)
  cell: string;
}

/**
 * Publish a PRIVATE app.aid.mod.appeal (moderation spec §7). The key IS the
 * identity (self-sovereign, no proofing) — signed, sealed statement, POSTed to
 * the moderation service (next-tier review), never the firehose.
 */
export async function publishAppeal(
  client: BeaconClient,
  input: AppealInput,
  postUrl: string,
  fetchImpl: typeof fetch = fetch,
): Promise<void> {
  const snap = await client.epochSnapshot();
  const statement = await client.sealBroadcastWith(snap, utf8(input.statement.trim() || "—"));
  await postSignedToService(
    client,
    { $type: "app.aid.mod.appeal", payload: { action: input.action, statement }, cell: input.cell },
    postUrl, fetchImpl, "appeal",
  );
}
